module.exports = __webpack_public_path__ + "static/media/french-flag.7bb380f0.svg";